import React, { useEffect, useState } from 'react';
import { Card, Form, Button } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import PageHeader1 from '../../components/common/PageHeader1';
import apiClient from "../../utils/api";
import { toast } from 'react-toastify';

function ValetPointsEdit() {
    const navigate = useNavigate();
    const { id } = useParams();

    const [formData, setFormData] = useState({
        name: '',
        location_id: '',
        is_active: "1"
    });

    const [locations, setLocations] = useState([]);

    useEffect(() => {
        fetchLocations();
        fetchValetPoint();
    }, [id]);

    const fetchLocations = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get('accounts/exit-locations', {
                headers: { Authorization: `Bearer ${token}` }
            });
            setLocations(response.data.data);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to load locations');
        }
    };

    const fetchValetPoint = async () => {
        try {
            const token = localStorage.getItem('auth_token');
            const response = await apiClient.get(`accounts/valet-points/${id}`, {
                headers: { Authorization: `Bearer ${token}` }
            });
            setFormData(response.data.data);
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to fetch valet point data');
            navigate('/accounts/valet-points-list');
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        const data = new FormData();
        data.append('name', formData.name);
        data.append('location_id', formData.location_id);
        data.append('is_active', formData.is_active);
        data.append('_method', 'PUT');

        try {
            const token = localStorage.getItem('auth_token');
            await apiClient.post(`accounts/valet-points/${id}`, data, {
                headers: { Authorization: `Bearer ${token}` }
            });
            toast.success('Valet point updated successfully');
            navigate('/accounts/valet-points-list');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Failed to update valet point');
        }
    };

    return (
        <div className="container-xxl">
            <PageHeader1 pagetitle="Edit Valet Point" />
            <div className="row g-3">
                <div className="col-xl-12">
                    <Card>
                        <Card.Body>
                            <Form onSubmit={onSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Label>Location</Form.Label>
                                            <Form.Select
                                                name="location_id"
                                                value={formData.location_id}
                                                onChange={handleInputChange}
                                                required
                                            >
                                                <option value="">Select Location</option>
                                                {locations.map(loc => (
                                                    <option key={loc.id} value={loc.id}>{loc.name}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Label>Point Name</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleInputChange}
                                                required
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-md-12">
                                        <Form.Group>
                                            <Form.Label>Status</Form.Label>
                                            <Form.Select
                                                name="is_active"
                                                value={formData.is_active}
                                                onChange={handleInputChange}
                                            >
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </Form.Select>
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Button type="submit" variant="primary">
                                            Update Valet Point
                                        </Button>
                                    </div>
                                </div>
                            </Form>
                        </Card.Body>
                    </Card>
                </div>
            </div>
        </div>
    );
}

export default ValetPointsEdit;
